{
  "version": 1,
  "asset_id": "1b713448-f89f-49b4-b857-5b8facddf988",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/1b713448-f89f-49b4-b857-5b8facddf988/wordmark-240.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/1b713448-f89f-49b4-b857-5b8facddf988/wordmark-240.webp",
  "original_filename": "wordmark-240.webp",
  "size": 8114,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:19:02Z"
}
